export enum AskSupportTrigger {
  ERROR= 'error',
  TIMEOUT = 'timeout',
  IMMEDIATE = 'immediate'
}
